<template>
  <div>
    <a-card size="small" class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item label="名称"><a-input v-model="filterForm.title" @change="onSearch" /> </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <div class="filter-action">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="导航列表" size="small" class="navigation-list">
      <a-button slot="extra" v-has="{ code: 'system:navigation:add', project: 0 }" type="primary" icon="plus" @click="onAdd"> 添加 </a-button>
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="navigationItems" row-key="id" @change="handleTableChange">
        <span slot="logo" slot-scope="text, record">
          <a-avatar :src="record.logo" />
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:navigation:edit', project: 0 }" @click="onEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:navigation:edit', project: 0 }" @click="onDelete(record)">删除</a>
        </span>
      </a-table>
    </a-card>
    <navigation-modal :is-show="visible" :navigation-id="navigationId" :navigation-data="navigationData" @close="close" />
  </div>
</template>

<script>
import { navigationList, navigationDelete } from '@/api/system/navigation';
import NavigationModal from '@/pages/system/navigation/NavigationModal';
const columns = [
  {
    title: 'Logo',
    dataIndex: 'logo',
    key: 'logo',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'logo' }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '名称',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '描述',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: '分类',
    dataIndex: 'category_name',
    key: 'category_name'
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: 170,
    align: 'center'
  },
  {
    title: '操作',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  components: {
    NavigationModal
  },
  props: {
    categoryId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      loading: false,
      navigationId: null,
      navigationData: {},
      navigationItems: [],
      visible: false,
      filterForm: {
        title: null,
        category_id: null
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },

  watch: {
    categoryId() {
      this.filterForm.category_id = this.categoryId;
      this.onSearch();
    }
  },

  created() {
    this.getNavigationList();
  },

  methods: {
    onSearch() {
      this.pagination.current = 1;
      this.getNavigationList();
    },
    getNavigationList() {
      this.loading = true;
      navigationList({
        ...this.filterForm,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.navigationItems = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDelete(navigation) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除这个导航吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          navigationDelete({ id: navigation.id }).then(() => {
            self.$message.success('删除成功');
            self.getNavigationList();
          });
        }
      });
    },

    onAdd() {
      this.visible = true;
    },

    onEdit(navigation) {
      this.navigationId = navigation.id;
      this.navigationData = navigation;
      this.visible = true;
    },

    onReset() {
      this.filterForm.title = null;
      this.pagination.current = 1;
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.getNavigationList();
    },

    close(type = 'submit') {
      this.visible = false;
      this.navigationId = null;
      this.navigationData = {};
      if (type === 'submit') {
        this.getNavigationList();
      }
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getNavigationList();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  margin-bottom: 16px;
  .ant-form-item {
    margin: 8px 0;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
  .filter-action {
    margin: 8px 0;
  }
}

/deep/.navigation-list {
  .ant-card-body {
    overflow: scroll;
    height: calc(~'100vh - 288px');
  }
}
</style>
